import { Navigate } from "react-router-dom";

/**
 * Lịch nghỉ moved onto the clinic settings page (#18860).
 *
 * <p>"Giờ làm việc" (recurring weekdays) and "Ngày nghỉ" (specific dates) answer one question —
 * when is the clinic shut — and used to live in two different settings groups, so saying "closed on
 * Saturdays" and "closed on 2/9" meant visiting two places.
 *
 * <p>The route stays and redirects rather than 404s: it is bookmarked, and it is linked from
 * elsewhere in the app.
 */
export function HolidaysSettingsPage() {
  return <Navigate to="/settings/clinic" replace />;
}
